import { Field } from 'formik';
import { useIntl } from 'react-intl';
import { FieldProps } from '../../types/fields';
import { config } from '../../utils/config';
import { Country } from '../../utils/countryData';
import getValidator from '../../utils/getValidator';
import TextField from '../formik/TextField';

type CityFieldProps = FieldProps & { country: Country; onBlur: () => void };

const CityField = ({ context, testIdPrefix, country, onBlur }: CityFieldProps) => {
  const { formatMessage } = useIntl();
  const { city: cityConfig } = config.addressForm[country].zipCodeCity;

  return (
    <div className="form__field-container" style={{ flex: context ? 4 : 3 }}>
      <Field
        onBlur={onBlur}
        name={[context, 'city'].filter(Boolean).join('.')}
        component={TextField}
        label={formatMessage({ id: 'address.city' })}
        maxLength={cityConfig?.maxLength ?? 50}
        validate={getValidator({ required: true, minLength: 3, format: 'streetOrCity', ...cityConfig })}
        data-test-id={`${testIdPrefix}-city`}
      />
    </div>
  );
};

export default CityField;
